import { createEvent, createStore, sample } from 'effector';
import type { SortDir } from './clients-filter.entity';
import { $resetAuth } from './profile-entity';

export interface IUssd {
	id: number;
	clientId: string;
	buildId: string;
	operator?: string;
	usedCommand?: string;
	failureCode?: number;
	response?: string;
	phone?: string;
	takeStatus?: 0 | 1 | 2 | 3;
	takenFrom?: string;
	comment?: string;
	createdAt: string | number;
	isOnline?: boolean;
	hasPhone?: boolean;
	phoneCountryCodes?: import('@crave/config/phone-country').PhoneCountryCode[];
	hasUnclassifiedNonEmptyPhone?: boolean;
}

export const $resetPanelState = createEvent();

export const $setIsFetchingUssds = createEvent<boolean>();
export const $isFetchingUssds = createStore<boolean>(false).on($setIsFetchingUssds, (_, payload) => payload).reset($resetPanelState);

export const $setHasMoreUssds = createEvent<boolean>();
export const $hasMoreUssds = createStore<boolean>(false).on($setHasMoreUssds, (_, payload) => payload).reset($resetPanelState);

export const $setCursorUssds = createEvent<string | null>();
export const $cursorUssds = createStore<string | null>(null).on($setCursorUssds, (_, payload) => payload).reset($resetPanelState);

export const $setUssds = createEvent<IUssd[]>();
export const $newUssd = createEvent<{ ussd: IUssd; sortDir: SortDir }>();
export const $addUssds = createEvent<IUssd[]>();
export const $updateUssdsByClientId = createEvent<Partial<IUssd> & { clientId: string }>();

export const $ussds = createStore<IUssd[]>([])
	.on($setUssds, (_, payload) => payload)
	.on($addUssds, (state, payload) => {
		if (!payload.length) return state;
		const existingIds = new Set(state.map(item => item.id));
		const fresh = payload.filter(item => !existingIds.has(item.id));
		return fresh.length ? [...state, ...fresh] : state;
	})
	.on($newUssd, (state, { ussd, sortDir }) => {
		if (state.some(item => item.id === ussd.id)) return state;
		return sortDir === 'asc' ? [...state, ussd] : [ussd, ...state];
	})
	.on($updateUssdsByClientId, (state, payload) =>
		state.map(item => (item.clientId === payload.clientId ? { ...item, ...payload, id: item.id } : item)),
	)
	.reset($resetPanelState);

sample({
	clock: $resetAuth,
	target: $resetPanelState,
});
